module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1094.9fb79c42.jpg";